import { useContext } from "react";
import { MainContext } from "../../../../main/context/MainContextProvider";
import { RopCard1111AvailabilityAnalysisTaticoAggregated } from "../../types";
import { Grid } from "@mui/material";
import AvailabilityAnalysisTacticalChart, { ChartDataItem } from "./AvailabilityAnalysisTacticalChart";

export type AvailabilityAnalysisCardsProps = {
    data: RopCard1111AvailabilityAnalysisTaticoAggregated;
    onClusterClick?: (clusterName: string | null) => void;
};

export default function AvailabilityAnalysisCards({ data, onClusterClick }: AvailabilityAnalysisCardsProps) {
    const { theme } = useContext(MainContext);

    // Transformar dados para o formato genérico do gráfico
    const chartData: ChartDataItem[] = data.clusterAverages.map((cluster) => {
        const isDisponibilidadeOnOffEnabled = cluster.data.disponibilidadeOnOffEnabled ?? true;

        return {
            name: cluster.clusterName || "Sem Cluster",
            clusterId: cluster.clusterId || null,
            items: [
                ...(isDisponibilidadeOnOffEnabled ? [
                    {
                        itemName: "Sistema",
                        itemValue: cluster.data.systemAvailability * 100,
                        itemMeta: cluster.data.systemExpectedValue * 100,
                        color: "#60A5FA"
                    }
                ] : []),
                {
                    itemName: "Inversores",
                    itemValue: cluster.data.inverterAvailability * 100,
                    itemMeta: cluster.data.inverterExpectedValue * 100,
                    color: "#34D399"
                },
                ...(isDisponibilidadeOnOffEnabled ? [
                    {
                        itemName: "Contratual",
                        itemValue: cluster.data.contractualAvailability * 100,
                        itemMeta: cluster.data.contractualExpectedValue * 100,
                        color: "#F59E0B"
                    }
                ] : []),
            ]
        };
    });

    return (
        <Grid
            item
            xs={12}
            sx={{
                backgroundColor: theme.cardBoxBackgroudColor,
                borderRadius: "8px",
                padding: "16px",
                marginBottom: "12px",
            }}
        >
            <AvailabilityAnalysisTacticalChart
                data={chartData}
                showLegend={true}
                onCategoryClick={
                    onClusterClick
                        ? (item) =>
                              onClusterClick(item.clusterId ?? item.name ?? null)
                        : undefined
                }
            />
        </Grid>
    );
}